export const TABLE_PAGESIZE = 25;
export const GROUPED_TABLE_PAGESIZE = 25;
export const TOAST_MESSAGE = {
  SUCCESS: "success",
  ERROR: "error",
};
export const KENDO_DATE_FORMAT = "M/D/YYYY";
export const DATE_FORMAT = "MMM DD, YYYY";
export const CALENDAR_DATE_FORMAT = "MMM dd, yyyy";
export const TARGET_DETAIL_DATE_FORMAT = "MMM DD, yyyy";
export const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAopHrup/9sssoByfN8S7I
nW85wEPyvoyRHpoZiDgW7Uz/VNoPQTAX9vL/+3es8ORdCEf5GZACbes22mVEYmuF
UGfs+z5mzwixwJzGLqRcSryVGkz29nPhQdzaeMajR/U//MDADHwA+MUlAbvUPCpH
FZ1HXnQFLZGHBYAPZLV0Q1gr11OKLM0/QruPkn2SJJFk3bkIFqq/HCmRFVT1rUNu
OmYLRs2ErTJm2Wbz3+46M+FslTSY9F+9viwekLwIj+Xd4JWatIBlAet36jkrNQO1
fdP7PuJGAjuNbmLlmETdDPwAqRMtEWSuq/PcNCPsh3CukEm3hcv/nqJiSa3Peoyn
T7QbFMP504xvzwNvrJ2ei9xRf/FG2gq+c2gc3p07wbH8UXna3f3GJwTlOr0/+066
akofO9YKzTS+tHveYKE1qIj3wv6IUo5wTUDjQ9iJPr4Jat7BzC7dS7ZUslFkkTt8
Vt/LyOMmGj5ZOkPymBgq73SXxhoglGYmJEvWv2sQOehJIPaiogLSVzzTtyUwtTHa
2a0unmHq3K90pf4qedCVP9Sm+jG+PxO7WxC3Vy8ZlfXGDkIXtDKFJAMxkGqPGf5S
mIYdgcLMaPXGtVKfbFI39VJtvYtQh7PisAH6W7higrdOMED0oqyQpNfKLch5wQ/t
pBY2HHkI3EyxyWqWcwz5fKUCAwEAAQ==
-----END PUBLIC KEY-----`;
export const LEFT_DRAW_INDEX = -10;
export const DATETIME_FORMAT = "MMM DD, YYYY | h:mm A";
export const GIPHY_API_KEY = "9Ixlv3DWC1biJRI57RanyL7RTbfzz0o7";
export const DATE_VALIDATION_FORMAT = "YYYY-MM-DD";
export const DATE_MONTH_FORMAT = "MMMM";
export const DATE_TO_STORE = "yyyy-MM-DD";
export const INCOMING_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSSZ";
export const DATE_CHECKIN_FORMAT = "DD MMM YY";
export const CHIP_DATE_FORMAT = "MMM YYYY";
export const TIME_VALIDATION_FORMAT = "h:mm a";
export const NOTIFICATION_LIST_DATE = "MM/DD - hh:mm a";
export const NOTIFICATION_LIST_DATE_TIME = "M/D/YYYY | h:mm a";
export const ACTIVITY_LIST_DATE_TIME = "M/D/YYYY | h:mm a";
export const MONTH_DAY_FORMAT = "M/D/YYYY";
export const YEAR_MONTH_DAY_FORMAT = "YY/MM/DD";
export const DEFAULT_DAYSTOCOMPLETE = 7;
export const MIN_RESIZABLE_WIDTH = 80;

export const COMPANY_ADMIN = "CompanyAdmin";

export const ALL_SKILL = [
  "Often",
  "Sometimes",
  "Rarely",
  "Never",
  "Not applicable",
];
export const SKILL_RATING_OPTION = ALL_SKILL.map((res) => {
  return {
    value: res,
    name: res === "Not applicable" ? "NotApplicable" : res,
  };
});

export const STATUS = {
  INPROGRESS: "In progress",
  COMPLETED: "Completed",
  OVERDUE: "Overdue",
  INCOMPLETED: "Incomplete",
  COMPLETEDWITHOVERDUE: "Completed",
  COMPLETE: "Completed",
  DRAFT: "Draft",
  PLANNED: "Planned",
  PAUSED: "Paused",
  ACTIVE: "Active",
  PENDINGAPPROVAL: "Pending",
  NeedsHelp: "Need help",
  POSTTARGET: "Post target",
  NOTSTARTED: "Not started",
  REJECTED: "Rejected",
  ARCHIVED: "Archived",
  Hold: "Hold",
  Active: "Active",
  Overdue: "Overdue",
  Completed: "Completed",
  completed: "Completed",
  "In progress": "In progress",
};

export const TARGET_STATUS_COLOR = {
  ACTIVE: { color: "#07519C", backgroundColor: "#DAECFF" },
  COMPLETED: { color: "#0A652B", backgroundColor: "#D5F9E3" },
  OVERDUE: { color: "#C41313", backgroundColor: "#FFE6E6" },
  PENDING: { color: "#BC501C", backgroundColor: "#FFE8D6" },
  PAUSED: { color: "#202F43", backgroundColor: "#DDDBDB" },
};

export const TARGET_STATUS_COLOR_DARK = {
  ACTIVE: { backgroundColor: "#3481D2" },
  COMPLETED: { backgroundColor: "#00B389" },
  OVERDUE: { backgroundColor: "#FE4343" },
  PENDINGAPPROVAL: { backgroundColor: "#BC501C" },
  PAUSED: { backgroundColor: "#7B7D82" },
  PLANNED: { backgroundColor: "#2E9B9E" },
  DRAFT: { backgroundColor: "#5e6066" },
};
export const SUCCESS_STORY_STATUS = {
  Closed: "Closed",
  PreMeeting: "Pre-meeting",
  Draft: "Draft",
  SuccessStoryCreated: "Success story created",
  ConversationPoints: "Conversation points",
  Acknowledged: "Acknowledged",
  SuccessStoryCompleted: "Success story completed",
  Archived: "Archived",
};
export const PERFORMANCE_REVIEW_STATUS = {
  Draft: "Draft",
  Archived: "Archived",
  Closed: "Completed",
  PendingReviewer: "Pending reviewer",
  PendingEmployee: "Pending employee",
  PendingMeeting: "Pending meeting",
  Acknowledged: "Acknowledged",
  PreMeeting: "Pre-meeting",
};

export const CHECKINTYPE = {
  GENERAL: "General",
  EVENT: "Event",
  SUREVEY: "Survey",
};

export const FETCH_POLICY = {
  networkOnly: "network-only",
  cacheOnly: "cache-only",
  noCache: "no-cache",
  cacheFirst: "cache-first",
};

export const SEND_INVITE = "Send invite";
export const OTHER_REASON_OPTION = "Other (please specify)";
export const CONTACT_US = "https://www.ialign.work/";
export const CONTACT_US_EMAIL = "Support@ialign.work";
export const VISION_LIMIT = 25;
export const NOTIFICATION_LIMIT = 1000;
export const MARK_COMPLETE = "MarkComplete";
export const NEEDS_HELP = "NeedsHelp";
export const NOT_STARTED = "NotStarted";
export const MAKING_PROGRESS = "MakingProgress";

export const LINKEDTARGETTYPE = {
  vision: "vision",
  target: "target",
};

export const VIDEOPROVIDERS = ["youtube.com", "vimeo.com", "youtu.be"];

export const CHARACTER_LIMIT_FOR_VISION_DESCRIPTION = 170;

export const CHARACTER_LIMIT_FOR_RESPONSE = 600;
export const CHARACTER_LIMIT = 250;
export const CHARACTER_LIMIT_FOR_SS = 380;
export const REGEX_URL = /(https?:\/\/[^\s]+)/g;

export const REGEX_STRING = /^[a-zA-Z]+$/;

export const COACH_ROLE = [
  "Coach",
  "DepartmentCoach",
  "ExecutiveDepartmentCoach",
  "ExternalCoach",
];

/* export const acceptedAllFiles = [
  "image/jpeg",
  "image/png",
  "audio/mpeg",
  "audio/mp4",
  "video/mp4",
  "video/ogg",
  "video/x-ms-wmv",
  "application/x-mpegurl",
  "video/x-msvideo",
  "video/ms-asf",
  "video/x-m4v",
  "video/webm",
  "video/quicktime",
  "video/mpeg",
  "video/3gpp",
  "application/vnd.apple.mpegurl",
  "application/vnd.ms-excel",
  "application/pdf",
  "application/vnd.ms-powerpoint",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  "application/vnd.ms-word.document.macroEnabled.12",
  "application/vnd.ms-word.template.macroEnabled.12",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  "application/vnd.ms-excel.sheet.macroEnabled.12",
  "application/vnd.ms-excel.template.macroEnabled.12",
  "application/vnd.ms-excel.addin.macroEnabled.12",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.presentationml.template",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "application/vnd.ms-powerpoint.addin.macroEnabled.12",
  "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
  "application/vnd.ms-powerpoint.template.macroEnabled.12",
  "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
  "application/vnd.ms-access",
  "text/csv"
]; */

// {'image/*': ['.jpeg', '.png']}

export const acceptedAllFiles = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/msword",
  "application/pdf",
  "application/vnd.ms-powerpoint",
  "image/jpeg",
  "image/png",
  "audio/mpeg",
  "audio/mp4",
  "video/mp4",
  "video/ogg",
  "video/x-ms-wmv",
  "application/x-mpegurl",
  "video/x-msvideo",
  "video/ms-asf",
  "video/x-m4v",
  "video/webm",
  "video/quicktime",
  "video/mpeg",
  "video/3gpp",
  "application/vnd.apple.mpegurl",
];

export const alphabet = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];

export const QUESTION_TYPE = {
  DESCRIPTIVE: "Descriptive",
  SINGLECHOICE: "Single choice",
  YESNO: "Yes/No",
  MULTIPLECHOICE: "Multiple choice",
  STARRANKING: "Star ranking",
  EMOJIRANKING: "Emoji",
};

export const TARGET_RATING_OPTIONS = {
  AboveExpectations: "Above expectations",
  CannotRate: "No rating needed",
  DevelopmentNeeded: "Development needed",
  Exceptional: "Exceptional",
  RealignmentNecessary: "Realignment necessary",
  Successful: "Successful",
};
